import {
  AfterViewInit,
  OnDestroy,
  ViewChildren,
  QueryList,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  HostListener,
  Inject,
  OnInit,
  PLATFORM_ID,
  ChangeDetectorRef,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { Router } from '@angular/router';
import { SwiperOptions } from 'swiper/types';
import { isPlatformBrowser } from '@angular/common';
import { StorageService } from '../../../shared/services/storage.service';
import { GlobalService } from '../../../shared/services/global.service';
import { AuthService } from '../../../shared/services/auth.service';

interface FaqItem {
  id: number;
  question: string;
  answer: string;
  open: boolean;
  height: number;
}

@Component({
  selector: 'app-Landing',
  templateUrl: './Landing.component.html',
  styleUrls: ['./Landing.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LandingComponent implements OnInit, AfterViewInit, OnDestroy {
  scrolled = false;

  // Listen to window scroll
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  @ViewChild('scrollArea') scrollArea!: ElementRef;

  @ViewChildren('answerRef') answerRefs!: QueryList<ElementRef>;
  private isBrowser: boolean;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private globalService: GlobalService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.checkLogin();
  }

  ngAfterViewInit(): void {
    this.scrollArea.nativeElement.addEventListener('scroll', () => {
      const scrollTop = this.scrollArea.nativeElement.scrollTop;
      console.log('Container scroll Y:', scrollTop);
    });
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => this.styleBullets(), 50);
    }
    if (this.isBrowser) {
      setTimeout(() => {
        this.updateHeights();
        this.cdr.detectChanges();
      }, 0);

      window.addEventListener('resize', this.onResize);
    }

    if (this.scrollContainer) {
      this.scrollContainer.nativeElement.addEventListener(
        'scroll',
        (e: any) => {
          const y = e.target.scrollTop;
          this.scrolled = y > 150;
        }
      );
    }
  }
  checkLogin(): void {
    if (
      StorageService.getItem('accessToken') &&
      StorageService.getItem('self')
    ) {
      this.globalService.setAccessToken(StorageService.getItem('accessToken'));
      this.globalService.setSelf(StorageService.getItem('self'));
      this.reloadSelf();
    } else {
      this.router.navigateByUrl('auth/login');
    }
  }
  reloadSelf(): void {
    this.authService.self({ all: true }).subscribe(
      (data) => {
        this.globalService.setSelf({
          name: data.name,
          email: data.email,
          contact: data.contact,
          user_id: data.id,
          username: data.username,
          user_type: data.user_type,
          organisation_id: data.organisation_id,
          company_id: data?.company_id ? data?.company_id : null
        });
        this.router.navigateByUrl('/home');
      },
      (e) => {
        StorageService.clearAll();
        this.router.navigateByUrl('auth/login');
      }
    );
  }
  faqs: FaqItem[] = [
    {
      id: 1,
      question: 'What is ORBIT Office ERP?',
      answer:
        'ORBIT is an office management system developed and owned by Volmint Technologies. This office ERP is designed to streamline office operations and manage them with ease of technology, ensuring better communication, interdepartmental collaboration, and workflow efficiency.',
      open: true,
      height: 0
    },
    {
      id: 2,
      question: 'Is ORBIT secure for data management?',
      answer:
        'Absolutely, ORBIT is built with robust data security in mind. From encryption to role-based access restrictions, the system ensures that sensitive company information is properly safeguarded, providing you with confidence and peace of mind when managing key processes.',
      open: false,
      height: 0
    },
    {
      id: 3,
      question: 'What are the features of ORBIT?',
      answer:
        'ORBIT office ERP brings all your office operations under one roof. From managing and tracking employee data to organizational performance, the system offers document management, live reports & analytics, payroll management, access control, multi-department management, device management, holiday & leave tracking, and robust communication management to run an organization smoothly.',
      open: false,
      height: 0
    },
    {
      id: 4,
      question: 'Can we customize ORBIT as per our needs?',
      answer:
        'ORBIT is not limited to a particular interface; it offers customizable options as per your business needs. It allows adding or removing modules as per your unique business preference.',
      open: false,
      height: 0
    },
    {
      id: 5,
      question: 'Why ORBIT office ERP matters for business?',
      answer:
        'It helps to automate repetitive tasks so that employees can be devoted to crucial work and be more productive. Plus, it offers a centralized system to increase collaboration, automated notifications & alerts, multi-layer security, and live reports & analytics to make data-driven informed decisions.',
      open: false,
      height: 0
    }
  ];

  gifs: string[] = [
    'assets/images/Video 5 1256 1.webm',
    'assets/images/Automate-Selection (1) 4.webm',
    'assets/images/(1) 2.webm',
    'assets/images/1(1).webm',
    'assets/images/(1) 3.webm'
  ];
  selectedGif = 0;

  showGif(index: number) {
    this.selectedGif = index;
  }

  private styleBullets() {
    document
      .querySelectorAll('.swiper-pagination .swiper-pagination-bullet')
      .forEach((el) => {
        // setAttribute so we can include !important if needed
        el.setAttribute(
          'style',
          'width:40px !important; height:8px !important; border-radius:8px !important;' +
            'background:transparent !important; border:2px solid #7b2cbf !important;' +
            'margin:0 8px !important; box-sizing:border-box !important; display:inline-block !important; transition:all .25s ease !important;'
        );
      });
  }

  @ViewChild('processImage') processImage!: ElementRef;
  @ViewChild('topContent') topContent!: ElementRef;
  @ViewChild('heroSection') heroSection!: ElementRef;

  private ticking = false; // prevents too many updates

  @HostListener('document:scroll', [])
  onDocumentScroll() {
    const y =
      document.documentElement.scrollTop || document.body.scrollTop || 0;
    console.log('Document scroll Y:', y);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    console.log('Scroll Y:', window.scrollY);

    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.applyScrollEffects();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  private applyScrollEffects() {
    const hero = this.heroSection.nativeElement;
    const topEl = this.topContent.nativeElement;
    const imgEl = this.processImage.nativeElement;

    const scrollY = window.scrollY;

    if (scrollY < 300) {
      const opacity = 1 - scrollY / 300;
      const translate = -scrollY / 4; // slower, smoother movement

      topEl.style.opacity = String(opacity);
      topEl.style.transform = `translateY(${translate}px)`;

      // processImage scrolls up, eased
      const imgTranslate = -scrollY / 6; // moves even slower for depth feel
      imgEl.style.transform = `translateY(${imgTranslate}px)`;
      imgEl.style.opacity = '1';
    } else {
      // release hero
      // hero.classList.remove('sticky', 'top-0');

      topEl.style.opacity = '0';
      topEl.style.transform = 'translateY(-80px)';

      imgEl.style.opacity = '1';
      imgEl.style.transform = 'translateY(0px)';
    }
  }

  private onResize = () => {
    this.updateHeights();
    this.cdr.detectChanges();
  };

  private updateHeights() {
    if (!this.isBrowser) return;

    const elems = this.answerRefs.toArray();
    elems.forEach((el, idx) => {
      const inner =
        el.nativeElement.querySelector('.answer-inner') || el.nativeElement;
      if (inner && inner.scrollHeight) {
        this.faqs[idx].height = inner.scrollHeight;
      }
    });
  }

  toggleFaq(id: number) {
    if (!this.isBrowser) return;

    const elems = this.answerRefs.toArray();

    setTimeout(() => {
      const heights = elems.map((el) => {
        const inner =
          el.nativeElement.querySelector('.answer-inner') || el.nativeElement;
        return inner ? inner.scrollHeight : 0;
      });

      this.faqs = this.faqs.map((faq, index) => {
        const isOpening = faq.id === id ? !faq.open : false;
        return {
          ...faq,
          open: isOpening,
          height: isOpening ? heights[index] : 0
        };
      });

      this.cdr.detectChanges();
    }, 0);
  }

  swiperConfig: SwiperOptions = {
    loop: true,
    freeMode: {
      enabled: true,
      momentum: false
    },
    autoplay: {
      delay: 1,
      disableOnInteraction: false
    },
    speed: 3000,
    slidesPerView: 1,
    spaceBetween: 16,
    breakpoints: {
      640: { slidesPerView: 2 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 }
    }
  };

  selectedIndex = 0;
  interval: any;
  loginStatus: any;
  blogs: any = [
    {
      title: 'Why ORBIT Office ERP is a Game-Changer for Office Teams',
      content:
        'Organizations often face challenges like manual workflows, delayed communication, and inefficient task tracking. ORBIT Office ERP streamlines these processes, reducing stress and improving productivity across teams.',
      image: './assets/images/blogs-images/enroll-stressbuster.jpg'
    },
    {
      title: 'Maximize Efficiency with ORBIT Office ERP’s Advanced Modules',
      content:
        'Modern organizations require seamless operations and effective collaboration. ORBIT Office ERP provides advanced modules to automate workflows, manage documents, and ensure smooth communication, enhancing overall operational efficiency.',
      image: './assets/images/blogs-images/maximize-efficiency.jpeg'
    },
    {
      title: 'Unlock New Potential with ORBIT Office ERP',
      content:
        'Equip your team with tools to simplify complex processes. ORBIT Office ERP offers a comprehensive solution for organized, efficient, and transparent office management, empowering teams to focus on strategic growth.',
      image: './assets/images/card-three.png'
    }
  ];

  ngOnInit(): void {
    this.interval = setInterval(() => {
      this.selectedIndex = (this.selectedIndex + 1) % 4; // Cycle through 0, 1, 2
    }, 3000);

    this.loginStatus = localStorage.getItem('self');
  }

  functions: any = [
    {
      icon: 'fa-regular fa-circle-check',
      content: 'Track attendance with ease'
    },
    {
      icon: 'fa-regular fa-circle-check',
      content: 'Schedule shifts effortlessly'
    },
    {
      icon: 'fa-regular fa-circle-check',
      content: 'Track days off efficiently'
    },
    {
      icon: 'fa-regular fa-circle-check',
      content: 'Convert time to timesheets'
    }
  ];

  openOrganizaton() {
    this.router.navigateByUrl('organization');
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    if (this.isBrowser) {
      window.removeEventListener('resize', this.onResize);
    }
  }

  goTo(url) {
    this.router.navigateByUrl(url);
  }
}
